import { useEffect, useState } from "react";
import { z } from "zod";

import { getDevice, CognitoLoginParams, login } from "@smart/auth-srp-dom";

import { Setters } from "./step";

export const loginSchema = z.object({
  username: z.string(),
  password: z.string(),
});

export type LoginParams = z.infer<typeof loginSchema>;

export const mfaSchema = z.object({
  code: z.string(),
});

export type MFAParams = z.infer<typeof mfaSchema>;

export type LoginSRP = {
  initial?: Partial<LoginParams>;
  cognito: CognitoLoginParams;
  local?: boolean;
};

export const useSRP = ({
  initial,
  cognito,
  setEmail,
  setStep,
}: LoginSRP & Setters) => {
  const [loading, setLoading] = useState(
    !!(initial?.username && initial?.password),
  );
  const [generator, setGenerator] = useState<ReturnType<typeof login>>();
  const start = async ({ username, password }: LoginParams) => {
    setLoading(true);
    const device = await getDevice(username);
    const newGenerator = login({
      ...cognito,
      username,
      password,
      device,
    });
    const result = await newGenerator.next();
    setGenerator(newGenerator);
    setLoading(false);
    setEmail(username);
    setStep({ ...result.value });
  };
  const next = async ({ code }: { code?: string }) => {
    if (generator) {
      setLoading(true);
      const result = await generator.next(code || "");
      setLoading(false);
      setStep(result.value);
    }
  };

  useEffect(() => {
    if (initial?.username && initial?.password) {
      start({ username: initial.username, password: initial.password }).catch(
        console.error,
      );
    }
  }, [initial?.username, initial?.password]);

  return {
    start,
    next,
    loading,
    initial,
  };
};
